'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BibItemInfo = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _formatIndicator = require('@bibliocommons/format-indicator');

var _formatIndicator2 = _interopRequireDefault(_formatIndicator);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _sharedBibBrief = require('@bibliocommons/shared-bib-brief');

var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);

var _availabilityBibBlock = require('@bibliocommons/availability-bib-block');

var _availabilityBibBlock2 = _interopRequireDefault(_availabilityBibBlock);

require('../styles/BibItemInfo.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BibItemInfo = exports.BibItemInfo = function (_BcReactComponent) {
  _inherits(BibItemInfo, _BcReactComponent);

  function BibItemInfo(props) {
    _classCallCheck(this, BibItemInfo);

    var _this = _possibleConstructorReturn(this, (BibItemInfo.__proto__ || Object.getPrototypeOf(BibItemInfo)).call(this, props));

    _this.bindAll('renderPubYear', 'renderAvailability', 'focusOnTitle');
    return _this;
  }

  _createClass(BibItemInfo, [{
    key: 'renderPubYear',
    value: function renderPubYear() {
      var bib = this.props.bib;

      var briefInfo = bib.get('briefInfo');
      if (briefInfo.get('publicationDate')) {
        return _react2.default.createElement(
          'span',
          { className: 'pub-year' },
          briefInfo.get('format') ? ' - ' : '',
          briefInfo.get('publicationDate')
        );
      }

      return _react2.default.createElement('noop', null);
    }
  }, {
    key: 'focusOnTitle',
    value: function focusOnTitle() {
      if (this._bibBrief) {
        this._bibBrief.focusOnTitle();
      }
    }
  }, {
    key: 'renderAvailability',
    value: function renderAvailability() {
      var bib = this.props.bib;

      var availability = bib.get('availability');

      if (availability && this.props.showAvailability) {
        return _react2.default.createElement(_availabilityBibBlock2.default, {
          bib: bib,
          availabilityStatus: availability,
          availabilityDetailActions: this.props.availabilityDetailActions,
          showAvailabilityLink: false });
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var bib = this.props.bib;

      var classes = this.props.compact ? 'compact' : '';
      var briefInfo = bib.get('briefInfo');

      return _react2.default.createElement(
        'div',
        {
          className: 'cp-catalogue-results-bib-item-info ' + classes,
          'data-test-item-bib-id': briefInfo.get('id') },
        _react2.default.createElement(
          _sharedBibBrief2.default,
          {
            ref: function ref(el) {
              return _this2._bibBrief = el;
            },
            bib: briefInfo,
            renderTitleAsLink: false,
            renderAuthorsAsLink: false,
            titleTag: 'h3' },
          _react2.default.createElement(
            'div',
            { className: 'format-and-year' },
            _react2.default.createElement(_formatIndicator2.default, { format: briefInfo.get('format').toUpperCase() }),
            this.renderPubYear()
          )
        ),
        this.renderAvailability()
      );
    }
  }]);

  return BibItemInfo;
}(_baseBcReactComponent2.default);

BibItemInfo.propTypes = {
  bib: _bcPropTypes.bibShape.isRequired,
  showAvailability: _react.PropTypes.bool,
  compact: _react.PropTypes.bool,
  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
};

exports.default = BibItemInfo;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/catalogue-results/components/bib-item-info/components/BibItemInfo.component.js
// module id = 509
// module chunks = 1